module.exports = __webpack_public_path__ + "img/3.ae5e857c.png";